"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@workspace/ui/components/button";
import { BackButton } from "@/components/error-page/back-button";
import { ErrorPageFooter } from "@/components/error-page/page-footer";
import { FlappyDrone } from "@/components/flappy-drone/flappy-drone";
import { useTrackAppInsightsException } from "@/hooks/use-track-app-insights-exception";
export default function ErrorBoundary(t0) {
  const $ = _c(22);
  const {
    error,
    reset
  } = t0;
  useTrackAppInsightsException(error, error.digest);
  const isConnectionError = error.message.includes("ECONNREFUSED") || error.message.includes("Failed query") || error.message.includes("connection") || error.message.includes("timeout");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FlappyDrone />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = isConnectionError ? "Connection issue" : "Something went wrong";
  let t3;
  if ($[1] !== t2) {
    t3 = <h1 className="text-xl font-semibold tracking-tight">{t2}</h1>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = isConnectionError ? "We're having trouble reaching the server. This is usually temporary \u2014 try again in a few seconds." : "An unexpected error occurred on our end. Try again, and if it keeps happening let us know.";
  let t5;
  if ($[3] !== t4) {
    t5 = <p className="text-muted-foreground text-sm">{t4}</p>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t3 || $[6] !== t5) {
    t6 = <div className="flex flex-col gap-2">{t3}{t5}</div>;
    $[5] = t3;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== reset) {
    t7 = <Button onClick={reset}>Try again</Button>;
    $[8] = reset;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <BackButton variant="outline" />;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7) {
    t9 = <div className="flex flex-col gap-2 sm:flex-row">{t7}{t8}</div>;
    $[11] = t7;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== error.digest) {
    t10 = error.digest && <p className="font-mono text-muted-foreground/60 text-xs">Error code <span className="text-magnus">{error.digest}</span></p>;
    $[13] = error.digest;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t6 || $[17] !== t9) {
    t11 = <div className="flex flex-1 items-center justify-center"><div className="flex max-w-md flex-col items-center gap-6 px-6 text-center">{t1}{t6}{t9}{t10}</div></div>;
    $[15] = t10;
    $[16] = t6;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <ErrorPageFooter />;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t11) {
    t13 = <div className="flex min-h-dvh flex-col bg-background">{t11}{t12}</div>;
    $[20] = t11;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  return t13;
}